import { jwtDecode } from "jwt-decode";
import { useEffect, useRef, useState } from "react";
import { Route, Routes, useNavigate, Navigate } from "react-router-dom";
import { Layout, Menu, message, Modal, ConfigProvider } from "antd";
import AMNS_Logo from '../../../App/Assets/amns_india.jpg';
import {LoginPage} from "./pages/LoginPage";
import {DashboardPage} from "./pages/DashboardPage";
import {LogEntryPage} from "./pages/LogEntryPage";
import {ReportPage} from "./pages/ReportPage";
import "./logsheet.css";
import { menuItems } from './constants';

const { Header, Sider, Content } = Layout;

const Logsheet = () => {
    const navigate = useNavigate();
    const wrapperRef = useRef(null);
    const [token, setToken] = useState(sessionStorage.getItem("token"));
    const [user, setUser] = useState();
    const [collapsed, setCollapsed] = useState(false);
    const userRole = user?.role;

    useEffect(() => {
        if (token) {
            const userData = jwtDecode(token);
            setUser(userData);
        }
    }, [token]);

    const handleMenuClick = (e) => {
        if (e.key === "logout") {
            handleLogout();
        } else {
            navigate(e.key);
        }
    };

    if (!token) {
        return (
            <div className="lg:logsheet-wrapper h-screen overflow-hidden">
                <Routes>
                    <Route path="/login" element={<LoginPage setToken={setToken} />} />
                    <Route path="*" element={<Navigate to="/logsheet/login" />} />
                </Routes>
            </div>
        );
    }

    const handleLogout = () => {
        Modal.confirm({
            title: "Confirm Logout",
            content: "Are you sure you want to log out?",
            okText: "Yes",
            cancelText: "Cancel",
            centered: true,
            okButtonProps: {
                danger: true,
            },
            onOk: () => {
                sessionStorage.removeItem("token");
                setToken(null);
                setUser(null);
                message.success("Logged out successfully");
            },
        });
    };

    

    return (
        <div ref={wrapperRef} className="lg:logsheet-wrapper xl:min-h-screen overflow-hidden">
        <ConfigProvider getPopupContainer={() => wrapperRef.current || document.body}>
        <Layout className="min-h-screen overflow-hidden">
            <Header className="bg-red-600 text-white h-14 shadow-sm flex items-center justify-between px-4">
                <div className="flex items-center space-x-2">
                    <img
                        src={AMNS_Logo}
                        className="h-8 w-16 lg:h-10 lg:w-20 rounded-md"
                        draggable={false}
                        alt="AMNS Logo"
                    />
                    <span className="text-sm lg:text-lg font-bold">Digital LogSheet</span>
                </div>
                <span className="hidden lg:block lg:text-lg font-semibold">
                    Welcome, {user?.email}
                </span>
            </Header>

            <Layout>
                <Sider collapsible collapsed={collapsed} onCollapse={setCollapsed}>
                    <Menu
                        theme="dark"
                        mode="inline"
                        selectedKeys={[window.location.pathname]}
                        items={menuItems}
                        onClick={handleMenuClick}
                    />
                </Sider>
                <Layout>
                    <Content className="p-6 logsheet-content">
                        <Routes>
                            <Route path="/dashboard" element={<DashboardPage user={user}/>}/>
                            <Route path="/log-entry" element={<LogEntryPage user={user}/>}/>
                            <Route path="/reports" element={<ReportPage user={user}/>}/>
                        </Routes>
                    </Content>
                </Layout>
            </Layout>
        </Layout>
        </ConfigProvider>
        </div>
    );
}

export default Logsheet;
